const __activate = {
  method: "POST",
  url: "sim/activate",
};

const __updateActivate = (uuid) => ({
  method: "POST",
  url: `sim/activate/${uuid}/update`,
});

const __getActivateBatches = {
  method: "GET",
  url: "sim/activate/batches",
};

const __activateTelit = {
  method: "POST",
  url: "sim/activate/telit",
};

const __activateSparq = {
  method: "POST",
  url: "sim/activate/sparq",
};

const __activateCricket = {
  method: "POST",
  url: "sim/activate/cricket",
};

const __activateVerizon = {
  method: "POST",
  url: "sim/activate/verizon",
};

const __activateTmobile = {
  method: "POST",
  url: "sim/activate/tmobile",
};

const __activateOPN = {
  method: "POST",
  url: "sim/activate/opn",
};

const __activateTmobilej = {
  method: "POST",
  url: "sim/activate/tmobilej",
};

const __activateNyx = {
  method: "POST",
  url: "sim/activate/nyx",
};

const __fetchKosherResellers = {
  method: "GET",
  url: "sim/tmobilej/kosher/resellers",
};

const __createKosherReseller = {
  method: "POST",
  url: "sim/tmobilej/kosher/resellers",
};

const __activateIT = {
  method: "POST",
  url: "sim/activate/it",
};

const __getActivate = {
  method: "GET",
  url: "sim/activate",
};

const __getActivateLog = (id) => ({
  method: "GET",
  url: `sim/activate/${id}`,
});

const __pause = {
  method: "POST",
  url: "sim/pause",
};

const __pauseTelit = {
  method: "POST",
  url: "sim/pause/telit",
};

const __pauseSelectel = {
  method: "POST",
  url: "sim/pause/selectel",
};

const __pauseTmobilej = {
  method: "POST",
  url: "sim/pause/tmobilej",
};

const __pauseSelectelRecheck = {
  method: "POST",
  url: "sim/pause/selectel/recheck",
};

const __getPause = {
  method: "GET",
  url: "sim/pause",
};

const __getPauseBatches = {
  method: "GET",
  url: "sim/pause/batches",
};

const __getPauseLog = (id) => ({
  method: "GET",
  url: `sim/pause/${id}`,
});

const __deactivate = {
  method: "POST",
  url: "sim/deactivate",
};

const __deactivateTelit = {
  method: "POST",
  url: "sim/deactivate/telit",
};

const __deactivateSparq = {
  method: "POST",
  url: "sim/deactivate/sparq",
};

const __deactivateTmobilej = {
  method: "POST",
  url: "sim/deactivate/tmobilej",
};

const __clearStatusTmobilej = {
  method: "POST",
  url: "sim/clear_status/tmobilej",
};

const __getClearStatusLog = (id) => ({
  method: "GET",
  url: `sim/clear_status/tmobilej/${id}`,
});

const __deactivateOPN = {
  method: "POST",
  url: "sim/deactivate/opn",
};

const __deactivateNyx = {
  method: "POST",
  url: "sim/deactivate/nyx",
};

const __getDeactivate = {
  method: "GET",
  url: "sim/deactivate",
};

const __getDeactivateBatches = {
  method: "GET",
  url: "sim/deactivate/batches",
};

const __getDeactivateLog = (id) => ({
  method: "GET",
  url: `sim/deactivate/${id}`,
});

const __restore = {
  method: "POST",
  url: "sim/restore",
};

const __unpauseSelectel = {
  method: "POST",
  url: "sim/unpause/selectel",
};

const __unpauseTmobilej = {
  method: "POST",
  url: "sim/unpause/tmobilej",
};

const __unpauseSelectelRecheck = {
  method: "POST",
  url: "sim/unpause/selectel/recheck",
};

const __getRestore = {
  method: "GET",
  url: "sim/restore",
};

const __getRestoreBatches = {
  method: "GET",
  url: "sim/restore/batches",
};

const __getRestoreLog = (id) => ({
  method: "GET",
  url: `sim/restore/${id}`,
});

const __unpause = {
  method: "POST",
  url: "sim/unpause",
};

const __getUnpause = {
  method: "GET",
  url: "sim/unpause",
};

const __getUnpauseBatches = {
  method: "GET",
  url: "sim/unpause/batches",
};

const __getUnpauseLog = (id) => ({
  method: "GET",
  url: `sim/unpause/${id}`,
});

const __changeNumber = {
  method: "POST",
  url: "sim/change_number",
};

const __updateChangeNumber = (uuid) => ({
  method: "POST",
  url: `sim/change_number/${uuid}/update`,
});

const __changeNumberTelit = {
  method: "POST",
  url: "sim/change_number/telit",
};

const __changeNumberSelectel = {
  method: "POST",
  url: "sim/change_number/selectel",
};

const __changeNumberSelectelRecheck = {
  method: "POST",
  url: "sim/change_number/selectel/recheck",
};

const __changeNumberTmobilej = {
  method: "POST",
  url: "sim/change_number/tmobilej",
};

const __changeNumberIT = {
  method: "POST",
  url: "sim/change_number/it",
};

const __getChangeNumber = {
  method: "GET",
  url: "sim/change_number",
};

const __getChangeNumberBatches = {
  method: "GET",
  url: "sim/change_number/batches",
};

const __getChangeNumberLog = (id) => ({
  method: "GET",
  url: `sim/change_number/${id}`,
});

const __changeSimUltra = {
  method: "POST",
  url: "sim/change_sim",
};

const __changeSimSelectel = {
  method: "POST",
  url: "sim/change_sim/selectel",
};

const __changeSimTmobilej = {
  method: "POST",
  url: "sim/change_sim/tmobilej",
};

const __changeSimIT = {
  method: "POST",
  url: "sim/change_sim/it",
};

const __getChangeSim = {
  method: "GET",
  url: "sim/change_sim",
};

const __getChangeSimBatches = {
  method: "GET",
  url: "sim/change_sim/batches",
};

const __getChangeSimLog = (id) => ({
  method: "GET",
  url: `sim/change_sim/${id}`,
});

const __getSimInfo = {
  method: "GET",
  url: "sim/sim_info",
};

const __getSimInfoBatches = {
  method: "GET",
  url: "sim/sim_info/batches",
};

const __fetchSimInfo = {
  method: "POST",
  url: "sim/sim_info",
};

const __fetchSimTelitInfo = {
  method: "POST",
  url: "sim/sim_info/telit",
};

const __fetchImsiStatus = {
  method: "POST",
  url: "sim/sim_info/imsi",
};

const __fetchSimSelectelInfo = {
  method: "POST",
  url: "sim/sim_info/selectel",
};

const __fetchSimOPNInfo = {
  method: "POST",
  url: "sim/sim_info/opn",
};

const __fetchSimTmobilejInfo = {
  method: "POST",
  url: "sim/sim_info/tmobilej",
};

const __fetchSimVSInfo = {
  method: "POST",
  url: "sim/sim_info/vs",
};

const __fetchSimITInfo = {
  method: "POST",
  url: "sim/sim_info/it",
};

const __fetchSimNyxInfo = {
  method: "POST",
  url: "sim/sim_info/nyx",
};

const __export = {
  method: "GET",
  url: "sim/export",
};

const __getPlans = {
  method: "GET",
  url: "sim/plans",
};

const __retryOperation = (batch_id) => ({
  method: "POST",
  url: `sim/retry_failed/${batch_id}`,
});

const __changePlan = {
  method: "POST",
  url: "sim/change_plan",
};

const __getChangePlanBatches = {
  method: "GET",
  url: "sim/change_plan/batches",
};

const __changePlanTelit = {
  method: "POST",
  url: "sim/change_plan/telit",
};

const __getChangePlan = {
  method: "GET",
  url: "sim/change_plan",
};

const __getChangePlanLog = (id) => ({
  method: "GET",
  url: `sim/change_plan/${id}`,
});

const __getRefillBatches = {
  method: "GET",
  url: "sim/refill/batches",
};

const __refillCricket = {
  method: "POST",
  url: "sim/refill/cricket",
};

const __refillOPN = {
  method: "POST",
  url: "sim/refill/opn",
};

const __refillVerizon = {
  method: "POST",
  url: "sim/refill/verizon",
};

const __refillIT = {
  method: "POST",
  url: "sim/refill/it",
};

const __getRefill = {
  method: "GET",
  url: "sim/refill",
};

const __getRefillLog = (id) => ({
  method: "GET",
  url: `sim/refill/${id}`,
});

const __getTelitExportList = {
  method: "GET",
  url: "sim/telit_export",
};

const __getTelitExportFile = {
  method: "GET",
};

const __telit_export = {
  method: "POST",
  url: "sim/sim_info/telit/export",
};

const __getTmobilejExportList = {
  method: "GET",
  url: "sim/tmobilej_export",
};

const __getTmobilejExportFile = {
  method: "GET",
};

const __tmobilej_export = {
  method: "POST",
  url: "sim/sim_info/tmobilej/export",
  // body: { filter_type: "All" | "Active" }
};

const __retryTmobilejExport = {
  method: "POST",
};

// VS Export (history + file + trigger)
const __getVSExportList = {
  method: "GET",
  url: "sim/vs_export",
};

const __getVSExportFile = {
  method: "GET",
};

const __vs_export = {
  method: "POST",
  url: "sim/sim_info/vs/export",
};

const __getZipCheckList = {
  method: "GET",
  url: "sim/zip_check",
};

const __getZipCheckFile = {
  method: "GET",
};

const __zipCheck = {
  method: "POST",
  url: "sim/sim_info/zip",
};

const __checkStatus = (batch_id) => ({
  method: "POST",
  url: `sim/recheck_status/${batch_id}`,
});

const __terminateProcess = (batch_id) => ({
  method: "POST",
  url: `sim/stop_batch/${batch_id}`,
});

const __getSparqSimGroups = {
  method: "GET",
  url: "sim/sparq_sim_group",
};

const __getCredential = (client) => ({
  method: "GET",
  url: `sim/credentials/${client}`,
});

const __updateCredential = (client) => ({
  method: "PUT",
  url: `sim/credentials/${client}`,
});

const __portin = {
  method: "POST",
  url: "sim/portin",
};

const __getPortinBatches = {
  method: "GET",
  url: "sim/portin/batches",
};

const __portinUltra = {
  method: "POST",
  url: "sim/portin/ultra",
};

const __portinTmobilej = {
  method: "POST",
  url: "sim/portin/tmobilej",
};

const __portinVS = {
  method: "POST",
  url: "sim/portin/vs",
};

const __getPortin = {
  method: "GET",
  url: "sim/portin",
};

const __getPortinLog = (id) => ({
  method: "GET",
  url: `sim/portin/${id}`,
});

const __updatePortinTmobilej = (id) => ({
  method: "POST",
  url: `sim/portin/tmobilej/${id}/update`,
});

const __cancelPortinTmobilej = (id) => ({
  method: "POST",
  url: `sim/portin/tmobilej/${id}/cancel`,
});

const __portout = {
  method: "POST",
  url: "sim/portout",
};

const __getPortoutBatches = {
  method: "GET",
  url: "sim/portout/batches",
};

const __portoutIT = {
  method: "POST",
  url: "sim/portout/it",
};

const __getPortout = {
  method: "GET",
  url: "sim/portout",
};

const __getPortoutLog = (id) => ({
  method: "GET",
  url: `sim/portout/${id}`,
});

// Update Number
const __getUpdateNumber = {
  method: "GET",
  url: "sim/update_number",
};

const __getUpdateNumberBatches = {
  method: "GET",
  url: "sim/update_number/batches",
};

const __getUpdateNumberLog = (id) => ({
  method: "GET",
  url: `sim/update_number/${id}`,
});

const __updateNumberTmobilej = {
  method: "POST",
  url: "sim/update_number/tmobilej",
};

const __updateNumberVS = {
  method: "POST",
  url: "sim/update_number/vs",
};

// MMS
const __getMms = {
  method: "GET",
  url: "sim/mms",
};

const __getMmsBatches = {
  method: "GET",
  url: "sim/mms/batches",
};

const __getMmsLog = (id) => ({
  method: "GET",
  url: `sim/mms/${id}`,
});

const __updateMmsTmobilej = {
  method: "POST",
  url: "sim/mms/tmobilej",
};

// Webhooks for update_number forms
const __getTmobilejWebhooks = {
  method: "GET",
  url: "sim/webhooks/tmobilej",
};

const __getVSWebhooks = {
  method: "GET",
  url: "sim/webhooks/vs",
};

const __clientActivate = {
  method: "POST",
  url: "clients/activate",
};

const __clientActivatePartner = {
  method: "POST",
  url: "clients/activate/partner",
};

const __clientDeactivate = {
  method: "POST",
  url: "clients/deactivate",
};

const __clientChangeNumber = {
  method: "POST",
  url: "clients/change_number",
};

const __clientSimInfo = {
  method: "POST",
  url: "clients/sim_info",
};

const __getUserHistory = {
  method: "POST",
  url: "sim/user_history",
};

const __reset = {
  method: "POST",
  url: "clients/reset/",
};

const __resetAdminUltra = {
  method: "POST",
  url: "sim/reset/",
};

const __resetAdminTelit = {
  method: "POST",
  url: "sim/reset/telit",
};

const __resetImsi = {
  method: "POST",
  url: "sim/reset/imsi",
};

const __getResetBatches = {
  method: "GET",
  url: "sim/reset/batches",
};

const __getReset = {
  method: "GET",
  url: "sim/reset",
};

const __setResetComplete = (batch_id) => ({
  method: "POST",
  url: `sim/reset/${batch_id}/complete`,
});

const __setResetFailed = (batch_id) => ({
  method: "POST",
  url: `sim/reset/${batch_id}/failed`,
});

const __searchLineClient = {
  method: "GET",
  url: `clients/search_lines`,
};

const __searchLine = {
  method: "GET",
  url: `sim/search_lines`,
};

const __hotlineSelectel = {
  method: "POST",
  url: "sim/hotline/selectel",
};

const __getHotline = {
  method: "GET",
  url: "sim/hotline",
};

const __getHotlineBatches = {
  method: "GET",
  url: "sim/hotline/batches",
};

const __getHotlineLog = (id) => ({
  method: "GET",
  url: `sim/hotline/${id}`,
});

const __getEsims = {
  method: "GET",
  url: "sim/esim",
};

const __addUltraEsim = {
  method: "POST",
  url: "sim/esim/ultra",
};

const __addPWGEsim = {
  method: "POST",
  url: "sim/esim/pwg",
};

const __getTmobilejIccidInventory = {
  method: "GET",
  url: "sim/iccid_inventory/tmobilej",
};

const __addTmobilejIccidInventory = {
  method: "POST",
  url: "sim/iccid_inventory/tmobilej",
};

const __wifiCallingAdminUltra = {
  method: "POST",
  url: "sim/wificalling",
};

const __getWifiCallingBatches = {
  method: "GET",
  url: "sim/wificalling/batches",
};

const __getWifiCalling = {
  method: "GET",
  url: "sim/wificalling",
};

const __getWifiCallingLog = (id) => ({
  method: "GET",
  url: `sim/wificalling/${id}`,
});

const __getOrganizations = {
  method: "GET",
  url: "sim/imsi/organizations",
};

const __imsiRegister = {
  method: "POST",
  url: "sim/imsi/register",
};

const __imsiUnregister = {
  method: "POST",
  url: "sim/imsi/unregister",
};

const __getIMSIBatches = {
  method: "GET",
  url: "sim/imsi/batches",
};

const __getIMSI = {
  method: "GET",
  url: "sim/imsi",
};

const __getIMSILog = (id) => ({
  method: "GET",
  url: `sim/imsi/${id}`,
});

const __getImsiWorkflowBatches = {
  method: "GET",
  url: "sim/imsi_workflow/batches",
};

const __getImsiWorkflow = {
  method: "GET",
  url: "sim/imsi_workflow",
};

const __getImsiWorkflowLog = (id) => ({
  method: "GET",
  url: `sim/imsi_workflow/${id}`,
});

const __imsiWorkflow = {
  method: "POST",
  url: "sim/imsi_workflow/ultra",
};

const __orderInfoTmobilej = {
  method: "POST",
  url: "sim/order_info/tmobilej",
};

const __getTmobilejSubscriber = (phone_number) => ({
  method: "GET",
  url: `tmobilej/${phone_number}/subscriber`,
});

const __createTmobilejSubscriber = (phone_number) => ({
  method: "POST",
  url: `tmobilej/${phone_number}/subscriber`,
});

const __getTmobilejCallFilters = (subscriber_id) => ({
  method: "GET",
  url: `tmobilej/${subscriber_id}/call-filter`,
});

const __createTmobilejCallFilter = (subscriber_id) => ({
  method: "POST",
  url: `tmobilej/${subscriber_id}/call-filter`,
});

const __updateTmobilejCallFilter = (subscriber_id, filter_id) => ({
  method: "PUT",
  url: `tmobilej/${subscriber_id}/call-filter/${filter_id}`,
});

const __deleteTmobilejCallFilter = (subscriber_id, filter_id) => ({
  method: "DELETE",
  url: `tmobilej/${subscriber_id}/call-filter/${filter_id}`,
});

const __getTmobilejMessageFilter = (subscriber_id) => ({
  method: "GET",
  url: `tmobilej/${subscriber_id}/message-filter`,
});

const __createTmobilejMessageFilter = (subscriber_id) => ({
  method: "POST",
  url: `tmobilej/${subscriber_id}/message-filter`,
});

const __updateTmobilejMessageFilter = (subscriber_id, filter_id) => ({
  method: "PUT",
  url: `tmobilej/${subscriber_id}/message-filter/${filter_id}`,
});

const __deleteTmobilejMessageFilter = (subscriber_id, filter_id) => ({
  method: "DELETE",
  url: `tmobilej/${subscriber_id}/message-filter/${filter_id}`,
});

const __getTmobilejCuratedGroups = () => ({
  method: "GET",
  url: "tmobilej/curated-groups",
});

const __getTmobilejCuratedGroup = (id) => ({
  method: "GET",
  url: `tmobilej/curated-groups/${id}`,
});

const __createTmobilejCuratedGroup = () => ({
  method: "POST",
  url: "tmobilej/curated-groups",
});

const __updateTmobilejCuratedGroup = (id) => ({
  method: "PUT",
  url: `tmobilej/curated-groups/${id}`,
});

const __deleteTmobilejCuratedGroup = (id) => ({
  method: "DELETE",
  url: `tmobilej/curated-groups/${id}`,
});

const __bulkAssignTmobilejFilterGroups = {
  method: "POST",
  url: "sim/tmobilej/filters/bulk-assign-groups",
};

const __getTmobilejFilterGroupAssignBatches = {
  method: "GET",
  url: "sim/tmobilej/filter_group_assign/batches",
};

const __getTmobilejFilterGroupAssignList = {
  method: "GET",
  url: "sim/tmobilej/filter_group_assign",
};

const __getTmobilejFilterGroupAssignLog = (id) => ({
  method: "GET",
  url: `sim/tmobilej/filter_group_assign/${id}`,
});

const __getOrderInfoBatches = {
  method: "GET",
  url: "sim/order_info/batches",
};

const __getOrderInfo = {
  method: "GET",
  url: "sim/order_info",
};

const __getOrderInfoLog = (id) => ({
  method: "GET",
  url: `sim/order_info/${id}`,
});

// PWG
const __activatePWG = {
  method: "POST",
  url: "sim/activate/pwg",
};

const __changeNumberPWG = {
  method: "POST",
  url: "sim/change_number/pwg",
};

const __changeSimPWG = {
  method: "POST",
  url: "sim/change_sim/pwg",
};

const __deactivatePWG = {
  method: "POST",
  url: "sim/deactivate/pwg",
};

const __restorePWG = {
  method: "POST",
  url: "sim/restore/pwg",
};

const __pausePWG = {
  method: "POST",
  url: "sim/pause/pwg",
};

const __unpausePWG = {
  method: "POST",
  url: "sim/unpause/pwg",
};

const __changePlanPWG = {
  method: "POST",
  url: "sim/change_plan/pwg",
};

const __portinPWG = {
  method: "POST",
  url: "sim/portin/pwg",
};

const __portinStatusPWG = {
  method: "POST",
  url: "sim/portin/pwg/status",
};

const __wifiCallingPWG = {
  method: "POST",
  url: "sim/wifi-calling/pwg",
};

const __querySimPWG = {
  method: "POST",
  url: "sim/query-sim/pwg",
};

const __queryUsagePWG = {
  method: "GET",
  url: "sim/query-usage/pwg",
};

const __fetchPWGPlans = {
  method: "GET",
  url: "sim/pwg/plans",
};

const __createPWGPlan = {
  method: "POST",
  url: "sim/pwg/plans",
};

const __fetchPWGPlanDetails = (id) => ({
  method: "GET",
  url: `sim/pwg/plans/${id}`,
});

const __updatePWGPlan = (id) => ({
  method: "PUT",
  url: `sim/pwg/plans/${id}`,
});

const __deletePWGPlan = (id) => ({
  method: "DELETE",
  url: `sim/pwg/plans/${id}`,
});

export {
  __activate,
  __updateActivate,
  __getActivate,
  __getActivateBatches,
  __activateTelit,
  __activateSparq,
  __activateCricket,
  __activateVerizon,
  __activateTmobile,
  __activateOPN,
  __activateTmobilej,
  __activateNyx,
  __fetchKosherResellers,
  __createKosherReseller,
  __activateIT,
  __getActivateLog,
  __pause,
  __pauseTelit,
  __pauseSelectel,
  __pauseTmobilej,
  __pauseSelectelRecheck,
  __getPause,
  __getPauseBatches,
  __getPauseLog,
  __deactivate,
  __getDeactivate,
  __getDeactivateBatches,
  __deactivateTelit,
  __deactivateSparq,
  __deactivateTmobilej,
  __clearStatusTmobilej,
  __getClearStatusLog,
  __deactivateOPN,
  __deactivateNyx,
  __getDeactivateLog,
  __restore,
  __unpauseSelectel,
  __unpauseTmobilej,
  __unpauseSelectelRecheck,
  __getRestore,
  __getRestoreBatches,
  __getRestoreLog,
  __unpause,
  __getUnpause,
  __getUnpauseBatches,
  __getUnpauseLog,
  __changeNumber,
  __updateChangeNumber,
  __changeNumberTelit,
  __changeNumberSelectel,
  __changeNumberSelectelRecheck,
  __changeNumberTmobilej,
  __changeNumberIT,
  __getChangeNumber,
  __getChangeNumberBatches,
  __getChangeNumberLog,
  __changeSimIT,
  __changeSimSelectel,
  __changeSimTmobilej,
  __changeSimUltra,
  __getChangeSim,
  __getChangeSimBatches,
  __getChangeSimLog,
  __getSimInfo,
  __fetchSimOPNInfo,
  __getSimInfoBatches,
  __fetchSimInfo,
  __fetchSimTmobilejInfo,
  __fetchSimVSInfo,
  __fetchSimITInfo,
  __fetchSimNyxInfo,
  __export,
  __getPlans,
  __retryOperation,
  __changePlan,
  __getChangePlanBatches,
  __changePlanTelit,
  __getChangePlan,
  __getChangePlanLog,
  __getRefillBatches,
  __refillCricket,
  __refillVerizon,
  __refillOPN,
  __refillIT,
  __getRefill,
  __getRefillLog,
  __getTmobilejExportList,
  __getTmobilejExportFile,
  __retryTmobilejExport,
  __tmobilej_export,
  __getVSExportList,
  __getVSExportFile,
  __vs_export,
  __getTelitExportList,
  __getTelitExportFile,
  __telit_export,
  __getZipCheckList,
  __getZipCheckFile,
  __zipCheck,
  __checkStatus,
  __terminateProcess,
  __getSparqSimGroups,
  __getCredential,
  __updateCredential,
  __portin,
  __getPortinBatches,
  __portinUltra,
  __portinTmobilej,
  __portinVS,
  __getPortin,
  __getPortinLog,
  __updatePortinTmobilej,
  __cancelPortinTmobilej,
  __portout,
  __getPortoutBatches,
  __portoutIT,
  __getPortout,
  __getPortoutLog,
  __getUpdateNumber,
  __getUpdateNumberBatches,
  __getUpdateNumberLog,
  __updateNumberTmobilej,
  __updateNumberVS,
  __getMms,
  __getMmsBatches,
  __getMmsLog,
  __updateMmsTmobilej,
  __getTmobilejWebhooks,
  __getVSWebhooks,
  __fetchSimTelitInfo,
  __fetchImsiStatus,
  __clientActivate,
  __clientActivatePartner,
  __clientChangeNumber,
  __clientDeactivate,
  __clientSimInfo,
  __getUserHistory,
  __reset,
  __resetAdminUltra,
  __resetAdminTelit,
  __resetImsi,
  __getResetBatches,
  __getReset,
  __setResetComplete,
  __setResetFailed,
  __searchLineClient,
  __searchLine,
  __fetchSimSelectelInfo,
  __hotlineSelectel,
  __getHotline,
  __getHotlineBatches,
  __getHotlineLog,
  __addUltraEsim,
  __addPWGEsim,
  __getEsims,
  __getTmobilejIccidInventory,
  __addTmobilejIccidInventory,
  __wifiCallingAdminUltra,
  __getWifiCallingBatches,
  __getWifiCalling,
  __getWifiCallingLog,
  __getOrganizations,
  __imsiRegister,
  __imsiUnregister,
  __getIMSIBatches,
  __getIMSI,
  __getIMSILog,
  __getImsiWorkflowBatches,
  __getImsiWorkflow,
  __getImsiWorkflowLog,
  __imsiWorkflow,
  __orderInfoTmobilej,
  __getTmobilejSubscriber,
  __createTmobilejSubscriber,
  __getTmobilejCallFilters,
  __createTmobilejCallFilter,
  __updateTmobilejCallFilter,
  __deleteTmobilejCallFilter,
  __getTmobilejMessageFilter,
  __createTmobilejMessageFilter,
  __updateTmobilejMessageFilter,
  __deleteTmobilejMessageFilter,
  __getTmobilejCuratedGroups,
  __getTmobilejCuratedGroup,
  __createTmobilejCuratedGroup,
  __updateTmobilejCuratedGroup,
  __deleteTmobilejCuratedGroup,
  __bulkAssignTmobilejFilterGroups,
  __getTmobilejFilterGroupAssignBatches,
  __getTmobilejFilterGroupAssignList,
  __getTmobilejFilterGroupAssignLog,
  __getOrderInfo,
  __getOrderInfoLog,
  __getOrderInfoBatches,
  __activatePWG,
  __changeNumberPWG,
  __changeSimPWG,
  __deactivatePWG,
  __restorePWG,
  __pausePWG,
  __unpausePWG,
  __changePlanPWG,
  __portinPWG,
  __portinStatusPWG,
  __wifiCallingPWG,
  __querySimPWG,
  __queryUsagePWG,
  __fetchPWGPlans,
  __createPWGPlan,
  __fetchPWGPlanDetails,
  __updatePWGPlan,
  __deletePWGPlan,
};
